<template>
  <div>
    <v-btn color="error" depressed @click="showConfirmReset" class="my-2" width="100%">Reset Application</v-btn>
    <loading-dialog :show="loading" message="Resetting application..."></loading-dialog>
    <message-box :show="messageShow" :message="message" :type="messageType"
                 v-on:close-message="messageShow = !messageShow"></message-box>
    <confirmation-box
        message="Reset application? note that this will invalidate all payments done and reset/remove information submitted to the system in the cause of this application. Proceed?"
        :show="showReset"
        v-on:positive="process"
        v-on:negative="showReset = false"
        title="warning"
        icon="mdi-warning"
    ></confirmation-box>
  </div>
</template>

<script>
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import ConfirmationBox from "@/components/ConfirmationBox";
import {mapGetters} from "vuex";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
export default {
  name: "ResetApplication",
  props: {
    noHeader: Boolean
  },
  components: {ConfirmationBox, MessageBox, LoadingDialog},
  data: () => ({
    showReset: false,
    messageType: '',
    message: '',
    messageShow: false,
    loading: false,
  }),

  methods: {
    process(){
      if(this.getUser == null)
        return

      this.loading = true
      this.showReset = false
      Api.applicants.resetApplication({
        applicant: this.getUser.userId,
        admission: this.getUser.admission.id
      }).then(res => {
        this.message = 'Application reset successfully'
        this.messageType = 'success'
        this.messageShow = true
        this.$store.commit("setCurrentUser", res.data);

        // reload
        window.location.reload()
      }).catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    showConfirmReset(){
      this.showReset = true
    }
  },

  computed: {
    ...mapGetters(['getUser'])
  }
}

</script>

<style scoped>

</style>
